import { Block as BaseBlock, BlockProps } from 'baseui/block';

export const Block = (props: BlockProps | any) => {
  return <BaseBlock {...props} />;
};
